/* eslint-disable prettier/prettier */
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { formatToBR } from '../../../utils/date'
import * as formatters from '../../../utils/formats'
import { ENUM_COMPANY, FILTER_EXTRACT } from '../../../constants/types'
import * as reducks from '../../../reducks'
import routes from '../../../config/routes'
import history from '../../../lib/history'
import DefaultLayout from '../../commons/Layouts/DefaultLayout'
import Text from '../../commons/Text/Text'
import Flex from '../../commons/Flex/Flex'
import Breadcrumb from '../../commons/Breadcrumb/Breadcrumb'
import Section from '../../commons/Section/Section'
import BoxIndicator from '../../commons/BoxIndicator/BoxIndicator'
import SectionIndicatorsManagerial from '../../commons/SectionIndicatorsManagerial/SectionIndicatorsManagerial'
import RatingBox from '../../commons/RatingBox/RatingBox'
import ProductBox from '../../commons/ProductBox/ProductBox'
import DatePicker from '../../commons/DatePicker/DatePicker'
import LoadingBounce from '../../commons/LoadingBounce/LoadingBounce'
import ModalInfo from '../../commons/ModalInfo/ModalInfo'
import StoreDescription from '../../commons/StoreDescription/StoreDescription'
import EmptyDataInPeriodExtract from '../../commons/EmptyDataInPeriodExtract/EmptyDataInPeriodExtract'
import styles from './extractContainer.module.scss'
import { USER_GOODS_AND_SERVICES } from '../../../constants/bussinesCode'

const breadcrumbs = [
  {
    id: 1,
    title: 'Carteira',
    path: routes.wallet.path
  },
  {
    id: 2,
    title: 'Extrato'
  }
]

const Extract = (props) => {
  const { match: { params: { id } = {} } = {} } = props

  const dispatch = useDispatch()

  const {
    getExtract,
    handleFilterManagements,
    handleCurrentExtract,
    receiveProduct
  } = reducks.resources.extract.actions

  useEffect(() => {
    dispatch(getExtract(id)).then(() => dispatch(handleFilterManagements(0)))
  }, [id])

  const { extract, currentExtracts, fetching } = useSelector(
    (state) => state.extractReducer
  )

  const businessCode = useSelector(
    (globalReducer) => globalReducer.currentUserReducer.businessCode
  )

  const isGoodsAndServices = businessCode === USER_GOODS_AND_SERVICES

  const {
    store,
    indicators: { priorities, profiles, classifications, managements } = {},
    products,
    currentYear,
    currentMonth
  } = extract

  const [showInfo, setShowInfo] = useState(false)
  const [info, setInfo] = useState({})
  const [filterActive, setFilterActive] = useState({
    id: 0,
    title: 'Todos'
  })
  const [storeSlice, setStoreSlice] = useState(3)
  const [profileSlice, setProfileSlice] = useState(6)

  const handleFilter = (filter) => {
    setFilterActive(filter)
    dispatch(handleFilterManagements(filter?.id))
  }

  const handleShowInfo = (item) => {
    const infos = {
      title: item?.value,
      description: item?.description
    }
    setShowInfo(true)
    setInfo(infos)
  }

  const applyFilterDate = (date) => {
    const { month, year } = date

    dispatch(
      reducks.resources.extract.actions.getExtract(id, {
        yearMonth: `${year}${month}`
      })
    ).then(() => dispatch(handleFilterManagements(0)))
  }

  return (
    <DefaultLayout>
      <ModalInfo
        visible={showInfo}
        title={info.title}
        description={info.description}
        callbackButtonOk={() => {
          setShowInfo(false)
          setInfo('')
        }}
      />

      <Flex column flex="1">
        <Flex alignItems="center" justifyContent="space-between">
          <Text color="gray" size="lg" variation="dark" bold>
            {store?.nameFantasy}
          </Text>
        </Flex>

        <Breadcrumb items={breadcrumbs} />

        <div className={styles.gridRow}>
          {!fetching && store && <StoreDescription store={store} />}

          {fetching && (
            <div className={styles.center}>
              <LoadingBounce />
            </div>
          )}

          <div className={styles.extract}>
            <Text color="gray" variation="dark" size="lg" bold>
              Extrato
            </Text>
            <Text
              color="gray"
              size="sm"
              font="custom"
              margin="12px 0px 0px 0px"
            >
              Acompanhe os indicadores e defina a melhor estratégia para atender
              o seu cliente
            </Text>
          </div>
        </div>

        {!isGoodsAndServices && (
          <Section
            title="Período visível"
            Actions={() => (
              <DatePicker
                applyFilter={applyFilterDate}
                initialValue={{
                  year: currentYear,
                  month: currentMonth
                }}
              />
            )}
          >
            {!fetching &&
              priorities?.map((prioritie, i) => {
                const { prefix, sufix, formatted } =
                  formatters.formatIndicatorsValueForType(
                    prioritie.value,
                    prioritie.formatId
                  )

                return (
                  <BoxIndicator
                    key={prioritie?.identifier}
                    active={i === 0}
                    smallTitle={prioritie?.name}
                    title={`${prefix}${formatted}${sufix}`}
                    updatedAt={`${prioritie?.periodicityName}, ${formatToBR(
                      prioritie?.referenceAt
                    )}`}
                    hasInfo={!!prioritie?.description}
                    margin="0 16px 0 0"
                    onClickInInfo={() => handleShowInfo(prioritie)}
                  />
                )
              })}

            {!fetching && priorities.length === 0 && (
              <EmptyDataInPeriodExtract />
            )}
          </Section>
        )}

        {fetching && (
          <div className={styles.center}>
            <LoadingBounce />
          </div>
        )}

        {!isGoodsAndServices && (
          <Section
            title="Indicadores de perfil"
            contentWrap="wrap"
            lastItem={profiles?.length === profileSlice}
            onClickSeeMore={
              profiles.length > 0
                ? () => setProfileSlice(profiles?.length)
                : null
            }
          >
            {!fetching &&
              profiles?.slice(0, profileSlice).map((profile, i) => {
                const { prefix, sufix, formatted } =
                  formatters.formatIndicatorsValueForType(
                    profile.value,
                    profile.formatId
                  )

                return (
                  <BoxIndicator
                    key={profile?.identifier}
                    active={i === 0}
                    height="147px"
                    width="258px"
                    margin="0 16px 16px 0"
                    smallTitle={profile?.name}
                    title={`${prefix}${formatted}${sufix}`}
                    FooterBox={() => (
                      <Text
                        size="xxs"
                        color={i === 0 ? 'white' : 'gray'}
                        variation="light"
                        font="custom"
                      >
                        {`${profile?.periodicityName}, ${formatToBR(
                          profile?.referenceAt
                        )}`}
                      </Text>
                    )}
                  />
                )
              })}

            {!fetching && profiles.length === 0 && <EmptyDataInPeriodExtract />}
          </Section>
        )}

        {!isGoodsAndServices && fetching && (
          <div className={styles.center}>
            <LoadingBounce />
          </div>
        )}

        {!isGoodsAndServices && (
          <SectionIndicatorsManagerial
            seeAllLink={routes.extractIndicatorsManagerial.path}
            indicators={currentExtracts?.slice(0, 2)}
            filters={managements?.length > 0 ? FILTER_EXTRACT : []}
            customEmptyMessage={
              managements?.length === 0
                ? 'Não existem dados para o período selecionado'
                : null
            }
            filterActive={filterActive}
            onClickFilter={handleFilter}
            handleIndicatorWithFilter={(indication) => {
              dispatch(handleCurrentExtract(indication))
            }}
          />
        )}

        {classifications && (
          <Section
            title="Classificação da loja"
            contentWrap="wrap"
            lastItem={classifications?.length === storeSlice}
            onClickSeeMore={
              !isGoodsAndServices && classifications?.length > 0
                ? () => setStoreSlice(classifications?.length)
                : null
            }
          >
            {classifications
              ?.slice(
                0,
                !isGoodsAndServices ? storeSlice : classifications.length
              )
              .map((rating, i) => (
                <RatingBox
                  key={rating.identifier}
                  title={rating.name}
                  subtitle={rating.value}
                  updatedAt={`${rating?.periodicityName}, ${formatToBR(
                    rating?.referenceAt
                  )}`}
                  classification={i === 0 ? rating.value : null}
                />
              ))}

            {!fetching && classifications.length === 0 && (
              <EmptyDataInPeriodExtract />
            )}
          </Section>
        )}

        {!isGoodsAndServices && (
          <Section title="Produtos no extrato">
            {!fetching && products.length > 0 && (
              <div className={styles.listProducts}>
                {products.map((product) => (
                  <ProductBox
                    key={product?.id}
                    title={product?.name}
                    image={product?.logoImageUrl}
                    description={ENUM_COMPANY.find(
                      (company) => company.company === product?.company
                    )}
                    onClick={() => {
                      dispatch(receiveProduct(product))

                      history.push(
                        `${routes.detailProduct.generate(id, product?.id)}`
                      )
                    }}
                  />
                ))}
              </div>
            )}
            {!fetching && products.length === 0 && <EmptyDataInPeriodExtract />}
          </Section>
        )}
      </Flex>
    </DefaultLayout>
  )
}

Extract.defaultProps = {
  history: {
    push: null
  },
  match: {}
}

Extract.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func
  }),
  match: PropTypes.shape({})
}

export default Extract
